import gql from "graphql-tag"

export default gql`
  query {
    currentUser {
      benchmarkSettings {
        recruiterType
        industry {
          id
          translationKey
        }
        companySize {
          id
          translationKey
          enoughData
        }
      }
    }

    industries {
      id
      translationKey
    }
  }
`
